import React, {useState} from "react";
import {stringUtil} from "../../../res/dataServices/string";
import TextInput from "../../../components/general/input/Input";
import {Button} from "../../../components/general/input/Button";

const Plus = () => {
    return (
        <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="9" width="4" height="18" rx="2" fill="white"/>
            <rect y="7" width="22" height="4" rx="2" fill="white"/>
        </svg>
    )
}

const Minus = () => {
    return (
        <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="7" width="22" height="4" rx="2" fill="white"/>
        </svg>
    )
}

const ProductQuantityInputButton = ({qtyEntered, updateQuantity, disabled, updating}) => {

    const [passedQtyEntered, setPassedQtyEntered] = useState(qtyEntered);
    const [inputQuantity, setInputQuantity] = useState(
        qtyEntered && qtyEntered > 0 ? qtyEntered : -1
    );

    if (passedQtyEntered !== qtyEntered) {
        setPassedQtyEntered(qtyEntered);
        setInputQuantity(qtyEntered);
    }

    const onQtyChanged = (e) => {
        const inputValue = e.target.value;
        const onlyNumbers = stringUtil.removeNonNumbers(inputValue);
        if (!onlyNumbers) {
            setInputQuantity(0);
        }

        const asNumber = Number(onlyNumbers);
        if (asNumber > 999) {
            setInputQuantity(999)
        } else if(asNumber < 1) {
            setInputQuantity(0);
        } else {
            setInputQuantity(asNumber);
        }
    }

    const onUpdateQuantity = (input) => {
        if(disabled) return;
        const qtyEntered = input > -1 ? input : inputQuantity;
        if(qtyEntered < 0) {
            updateQuantity(1);
        } else {
            updateQuantity(qtyEntered);
        }
    }

    const buttonClass = updating ? "loading" : disabled  ? "inactive" : "";

    return (
        <div className='prod-input-quantity-container button-input'>
            <Button
                className={buttonClass + " minus"}
                onClick={() => onUpdateQuantity(inputQuantity - 1)}
            >
                <Minus />
            </Button>
            <TextInput
                disabled={true}
                onChange={onQtyChanged}
                value={inputQuantity > -1 ? inputQuantity : ""}
            />
            <Button
                className={buttonClass + " plus"}
                onClick={() => onUpdateQuantity(Math.max(inputQuantity + 1, 1))}
            >
                <Plus/>
            </Button>
        </div>
    )

}

export default ProductQuantityInputButton;
